export default __webpack_public_path__ + "assets/bug.4bfe70cb.svg";